import { bffRetailMedia } from '~/middlewares/axios'

const baseURL = `/campaign`

export const linkCampaignCheckingAccountService = ({
  campaignId,
  body
}: LinkCampaignCheckingAccountRequest) =>
  bffRetailMedia.post<LinkCampaignCheckingAccountResponse>(
    `${baseURL}/${campaignId}/checking-accounts`,
    body
  )

export const unlinkCampaignCheckingAccountService = ({
  campaignId,
  campaignCheckingAccountId
}: UnlinkCampaignCheckingAccountRequest) =>
  bffRetailMedia.delete(
    `${baseURL}/${campaignId}/checking-accounts/${campaignCheckingAccountId}`
  )
